module.exports = __webpack_public_path__ + "img/bookmarks.87c278d9.jpg";